<template>
  <div class="row">
    <div class="col-12">
      <card>
        <vue-element-loading :text="loading.text" spinner="bar-fade-scale" :color="loading.color"
          :active="loading.active" :is-full-screen="false" />
        <div>
          <div class="col-sm-12 card">
            <el-table stripe style="width: 100%;" :data="tableData" size="mini" :row-class-name="getRowClass"
              @sort-change="handleSort">

              <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
                :prop="column.prop" :label="column.label" :sortable="column.sortable" :sort-method="column.sortMethod">
              </el-table-column>

              <el-table-column type="expand">
                <template slot-scope="props">
                  <p><b>Inscripcion:</b> {{ props.row.init_date }}</p>
                  <p><b>Vencimiento:</b> {{ props.row.final_date }}</p>
                  <p><b>Licencia:</b> {{ props.row.licencia }}
                    <a href="#" @click.prevent="copyToClipboard(props.row.licencia)" title="Copiar">
                      Copiar📋
                    </a>
                  </p>
                  <p><b>Codigo:</b> {{ props.row.codigo }}</p>
                  <!--   <p><b>Opcion:</b> {{ props.row.option_name }}</p> -->
                </template>
              </el-table-column>

              <el-table-column :min-width="80" label="Historial" fixed="right">
                <template slot-scope="props">
                  <a v-tooltip.top-center="'Ver historial'" class="px-1 btn-warning btn-simple btn-link"
                    @click="verHistorial(props.row)">
                    <i class="fa fa-history"></i>
                  </a>
                </template>
              </el-table-column>
              <el-table-column :min-width="120" fixed="right" label="Actions">


                <template slot-scope="props">
                  <a v-tooltip.top-center="'Editar'" class="px-1 btn-info btn-simple btn-link"
                    @click="update(props.row)">
                    <i class="fa fa-align-justify"></i>
                  </a>
                  <a v-tooltip.top-center="'Eliminar'" class="px-1 btn-danger btn-simple btn-link"
                    @click="showSwal('delete', props.row.id)"> X </a>


                  <a v-tooltip.top-center="'Enviar recordatorio'" class="px-1 btn-primary btn-simple btn-link"
                    @click="sendReminder(props.row.id)">
                    <i class="fa fa-bell"></i>
                  </a>
                </template>


              </el-table-column>

            </el-table>

          </div>
        </div>
        <div class="text-right">
          <downloadexcel :fetch="generateExcel" :fields="tableExcel" :before-generate="startDownload"
            :before-finish="finishDownload" type="csv" class="btn btn-filmker-pink btn-fill btn-sm">
            Descargar
          </downloadexcel>
        </div>
      </card>
    </div>
    <el-dialog center :visible.sync="change" :append-to-body="true" :modal-append-to-body="false">
              <vue-element-loading :text="loading.text" spinner="bar-fade-scale" :color="loading.color"
          :active="loading.active" :is-full-screen="false" />
      <div>
        <form id="edit_form">
          <div class="row">
            <div class="col-md-6">

              <fg-input type="text" label="Correo" placeholder="correo" v-model="device.correo"
                v-validate="modelValidations.correo" name="correo" :error="getError('usuario')">
              </fg-input>
              <fg-input type="text" label="Fecha de vencimiento">
                <input type="date" v-model="device.finall" class="form-control" name="finall"
                  :class="{ 'is-invalid': getError('finall') }" v-validate="modelValidations.finall" />
                <small v-if="getError('finall')" class="text-danger">{{ getError('finall') }}</small>
              </fg-input>

              <fg-input type="text" label="Hardware Id" placeholder="Ingrese el Hardware Id" v-model="device.hardwareid"
                v-validate="modelValidations.hardwareid" name="hardwareid" :error="getError('hardwareid')">
              </fg-input>

              <fg-input type="text" label="Módulos">
                <el-select multiple filterable v-model="device.modules" v-validate="modelValidations.modules"
                  name="modules" :error="getError('modules')" placeholder="Seleccione uno o varios módulos"
                  class="select-primary">
                  <el-option v-for="item in filteredModules" :key="item.id" :label="item.name"
                    :value="Number(item.id)" />
                </el-select>

              </fg-input>


            </div>
          </div>
          <div class="text-right">
            <button type="submit" class="btn btn-filmker-pink btn-fill btn-sm" @click.prevent="validate">
              Actualizar licencia
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </el-dialog>
    <!-- ... tras el primer el-dialog de edición ... -->

    <!-- ... tras el primer el-dialog de edición ... -->

    <el-dialog title="Historial de Licencia" :visible.sync="historialVisible" width="80%"  center>
         <vue-element-loading :text="loading.text" spinner="bar-fade-scale" :color="loading.color"
          :active="loading.active" :is-full-screen="false" />
      <el-table :data="historialData" stripe size="small" style="width: 100%;">
        <el-table-column prop="changed_at" label="Fecha de cambio" width="180" />
        <el-table-column prop="changed_by" label="Modificado por" width="120" />



        <el-table-column label="Vencimiento (Antes → Después)" width="240">
          <template slot-scope="scope">
            {{ scope.row.old_final_date }} → {{ scope.row.new_final_date }}
          </template>
        </el-table-column>

        <el-table-column label="Licencia Anterior" min-width="200">
          <template slot-scope="{ row }">
            <span>{{ row.old_licencia.slice(0, 30) }}…</span>
            <i class="fa fa-copy ml-2" style="cursor: pointer; color: #409EFF;" title="Copiar licencia anterior"
              @click="copyToClipboard(row.old_licencia)"></i>
          </template>
        </el-table-column>



        <el-table-column label="Licencia Nueva" min-width="200">
          <template slot-scope="{ row }">
            <span>{{ row.new_licencia.slice(0, 30) }}…</span>
            <i class="fa fa-copy ml-2" style="cursor: pointer; color: #409EFF;" title="Copiar licencia nueva"
              @click="copyToClipboard(row.new_licencia)"></i>
          </template>
        </el-table-column>

        <el-table-column label="Hardware Id" min-width="200">
          <template slot-scope="{ row }">
            <span>{{ row.hardwareid }}…</span>
          </template>
        </el-table-column>

      </el-table>
    </el-dialog>



  </div>


</template>
<script>
import swal from 'sweetalert2'
import { Dialog, Option, Select, Table, TableColumn } from 'element-ui'
import { Pagination as LPagination } from 'src/components/index'
import vueElementLoading from 'vue-element-loading'
import downloadexcel from "vue-json-excel";

export default {
  components: {
    LPagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    vueElementLoading,
    [Dialog.name]: Dialog,
    downloadexcel
  },
  data() {
    return {
      modules: [],
      historialVisible: false,
      historialData: [],
      dataFor: [],
      users: [],
      loading: {
        text: 'Please Wait',
        color: '#222',
        active: false
      },
      contacts: [],
      change: false,
      searchQuery: '',
      propsToSearch: ['email'],
      tableExcel: {
        'Contacto': 'usuario',
        'Dominio': 'dominio',
        'Licencia': 'licencia',
        'Codigo': 'codigo',
        'entorno': 'entorno',
        'Institucion': 'institutions',
        'Identificador': 'identifier',
        '#': 'identifies',
/*           'Compañia': 'company',
 */          'Telefono': 'phone',
        'Inscripcion': 'init_date',
        'Vencimiento': 'final_date',
        'Opcion': 'option_name'
      },
      tableColumns: [
        {
          prop: 'usuario',
          label: 'Contacto',
        },
        {
          prop: 'dominio',
          label: 'Dominio',
        },
        {
          prop: 'institutions',
          label: 'Institucion',
        },
        {
          prop: 'identifier',
          label: 'Identificador',
        },
        {
          prop: 'entorno',
          label: 'Entorno',
        },
        /*     {
              prop: 'company',
              label: 'Compañia',
            }, */
        {
          prop: 'init_date',
          label: 'Creación',
          sortable: true,
          sortMethod: this.sortByDate
        },
        {
          prop: 'final_date',
          label: 'Vencimiento',
          sortable: true,
          sortMethod: this.sortByDate
        },
      ],
      tableData: [],
      device: {
        usuario: '',
        finall: '',
        institutions: '',
        correo: '',
        institutions: '',
        identifier: '',
        id_identifier: '',
        modules: [],
        ambiente_id: '',
        licencia_id: '',
        company: '',
        dominio: '',

      },
      account: {},
      modelValidations: {
        usuario: {
          required: true
        },
        finall: {
          required: true,
        },
        correo: {
          required: true,
        },
        hardwareid: {
          required: true,
        }
      }
    }
  },
  computed: {


    isSmartConvertSelected() {
      const sel = this.identifier.find(i => Number(i.id) === this.device.identifier)
      return sel && sel.name === 'SmartConvert'
    },
    filteredModules() {

      return this.modules
    },
  },
  methods: {


    sendReminder(id) {
      this.loading.active = true;
      this.axios({
        url: `conexions.php`,
        method: 'post',
        data: { licencia_id: id },
        headers: {
          authorization: localStorage.token
        }
      })
        .then(response => {
          this.loading.active = false;
          this.showSwal('success', `Recordatorio enviado Correctamente`);
        })
        .catch(error => {
          this.loading.active = false;
          const message =
            error.response &&
              error.response.data &&
              error.response.data.message
              ? error.response.data.message
              : 'No se pudo enviar el recordatorio';
          this.showSwal('error', message);
        });

    },
    verHistorial(row) {
      this.loading.active = true;
      this.historialVisible = true;
      this.historialData = [];

      this.axios
        .get(`conexions.php?datos=8&licencia_id=${row.id}`, {
          headers: { authorization: localStorage.token }
        })
        .then(resp => {
          this.historialData = resp.data.message;
        })
        .catch(() => {
          this.showSwal('error', 'No se pudo cargar el historial');
        })
        .finally(() => {
          this.loading.active = false;
        });
    },

    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid)
          this.addDevice();
      })
    },
    addDevice() {
      this.loading.active = true
      this.axios({
        url: `conexions.php`,
        method: 'put',
        data: this.device,
        headers: {
          authorization: localStorage.token
        }
      })
        .then(response => {
          this.loading.active = false
          this.change = false
          this.clearModel()
          this.loadUsers()
          this.showSwal('success', 'Licencia Actualizada')
        })
        .catch(error => {
          this.loading.active = false
          this.showSwal('error', error.response.data.messages)
        })
    },
    showSwal(type, message) {
      if (type === 'success') {
        swal.fire({
          title: message,
          type: 'success'
        })
      } else if (type === 'error') {
        swal.fire({
          title: message,
          type: 'warning'
        })
      }
    },
    clearModel() {
      this.device = {
        usuario: '',
        finall: '',
        modules: '',
        ambiente_id: '',

      }
    },
    update(id) {
      this.change = true
      this.device.usuario = id.usuario;
      this.device.finall = id.final_date;
      this.device.hardwareid = id.hardwareid;
      this.device.institutions = id.institutions;
      this.device.licencia_id = Number(id.id);
      this.device.correo = id.correo;
      this.device.identifier = Number(id.id_identifier);
      this.device.modules = id.module_identifiers || [];
      this.device.ambiente_id = id.ambiente_id || "";
      this.device.company = id.company || "";
      this.device.correo = id.email || "";
      this.device.dominio = id.dominio || "";


    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    handleSort({ column, prop, order }) {
      if (!prop) return;

      this.tableData.sort((a, b) => {
        let valueA = a[prop];
        let valueB = b[prop];

        if (prop === "final_date") {
          valueA = new Date(valueA).getTime();
          valueB = new Date(valueB).getTime();
        }

        if (order === "ascending") {
          return valueA - valueB;
        } else if (order === "descending") {
          return valueB - valueA;
        }
        return 0;
      });
    },

    getUsers() {
      this.loading.active = true
      const headers = { authorization: localStorage.token }
      // Módulos
      this.axios.get(`conexions.php?datos=6`, { headers })
        .then(r => this.modules = r.data.message)
        .finally(() => this.loading.active = false)
      // Ambientes
      this.axios.get(`conexions.php?datos=7`, { headers })
        .then(r => this.ambientes = r.data.message)
        .finally(() => this.loading.active = false)


    },
    copyToClipboard(text) {
      if (!text) return;

      navigator.clipboard.writeText(text)
        .then(() => {
          alert("Licencia copiada al portapapeles");
        })
        .catch(() => {
          alert("Error al copiar");
        });
    },


    changePage() {
      this.loadUsers()
    },
    loadUsers() {
      this.loading.active = true
      this.axios({
        url: `conexions.php?datos=4&desde=null&hasta=null&user=null`,
        method: 'get',
        headers: {
          authorization: localStorage.token
        }
      })
        .then(response => {
          this.loading.active = false
          this.tableData = response.data.message
          this.dataFor = response.data.message
        })
        .catch(error => {
          this.loading.active = false
        })
    },
    generateExcel() {
      return this.tableData
    },
    handleDelete(id) {
      this.loading.active = true
      this.axios({
        url: `conexions.php?license=${id}`,
        method: 'delete',
        headers: {
          authorization: localStorage.token
        }
      })
        .then(response => {
          this.loading.active = false
          this.loadUsers()
          swal({
            title: 'Deleted!',
            text: response.message,
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          })
        })
        .catch(error => {
          this.loading.active = false
          swal({
            title: 'Deleted!',
            text: error.response.message,
            type: 'error',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          })
        })
    },
    startDownload() {
      this.showSwal('success', 'Iniciando Descarga')
    },
    finishDownload() {
      this.showSwal('success', 'Descarga Completada')
    },
    showSwal(type, id) {
      if (type === 'success') {
        swal.fire({
          title: id,
          type: 'success'
        })
      } else if (type === 'delete') {
        swal({
          title: '¿Esta seguro?',
          text: `Esta operación no puede ser revertida!`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Eliminar',
          buttonsStyling: false
        }).then((action) => {
          if (action.value) {
            this.handleDelete(id)
          }
        })
      }
    },
    getRowClass({ row }) {
      return this.isExpiringSoon(row.final_date, 60) ? "expiring-row" : "";
    },

    isExpiringSoon(finalDate, daysThreshold) {
      if (!finalDate) return false;

      const today = new Date();
      const expirationDate = new Date(finalDate);

      const daysLeft = (expirationDate - today) / (1000 * 60 * 60 * 24);

      return daysLeft <= daysThreshold && daysLeft >= 0;
    },

  },

  mounted() {
    this.getUsers()
  },
  created() {
    this.loadUsers(1)
  },

  watch: {
    searchQuery(value) {
      this.loadUsers(1)
    }
  }
}
</script>
<style>
.expiring-row td:nth-child(7) {
  background-color: yellow !important;
}
</style>
